import { request } from "@/api/server/index";

export default {
  //V007_グループスケジュール画面
  GroupSchedule: {
    // 初期表示
    indexGroupSchedule(params) {
      return request({
        url: "/groupSchedule/indexGroupSchedule",
        data: params,
        method: "post"
      });
    },
    // 出先切り替え、データ再取得
    searchInfoForBranchChange(params) {
      return request({
        url: "/groupSchedule/searchInfoForBranchChange",
        data: params,
        method: "post"
      });
    },
    // 週切り替え、データ再取得
    searchInfoForDateChange(params) {
      return request({
        url: "/groupSchedule/searchInfoForDateChange",
        data: params,
        method: "post"
      });
    },
    // 部署切り替え、データ再取得
    searchInfoForDepartmentChange(params) {
      return request({
        url: "/groupSchedule/searchInfoForDepartmentChange",
        data: params,
        method: "post"
      });
    }
  },
  // V020_対応予定・対応履歴登録
  ContactEdit: {
    // 対応予定・対応履歴 履歴初期表示
    indexContactEdit(params) {
      return request({
        url: "/contactEdit/indexContactEdit",
        data: params,
        method: "post"
      });
    },
    // 対応予定・対応履歴 予定初期表示
    indexContactTodoEdit(params) {
      return request({
        url: "/contactEdit/indexContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    //対応予定登録(新規登録)
    insertContactTodoEdit(params) {
      return request({
        url: "/contactEdit/insertContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    // 対応予定登録(編集)
    updateContactTodoEdit(params) {
      return request({
        url: "/contactEdit/updateContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    // 対応予定削除
    deleteContactTodoEdit(params) {
      return request({
        url: "/contactEdit/deleteContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    //対応履歴登録(新規登録)
    insertContactEdit(params) {
      return request({
        url: "/contactEdit/insertContactEdit",
        data: params,
        method: "post"
      });
    },
    //対応履歴登録(編集)
    updateContactEdit(params) {
      return request({
        url: "/contactEdit/updateContactEdit",
        data: params,
        method: "post"
      });
    },
    // 対応履歴削除
    deleteContactEdit(params) {
      return request({
        url: "/contactEdit/deleteContactEdit",
        data: params,
        method: "post"
      });
    },
    //  この予定を対応履歴に登録
    updateContact(params) {
      return request({
        url: "/contactEdit/updateContact",
        data: params,
        method: "post"
      });
    },
    // 部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/contactEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    }
  },
  //  V021_予定・対応漏れ一覧
  LeakContact: {
    // 初期表示
    indexLeakContact(params) {
      return request({
        url: "/leakContact/indexLeakContact",
        data: params,
        method: "post"
      });
    },
    // 部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/leakContact/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //検索(b9)ボタンをクリックしたときの処理
    searchLeakContactList(params) {
      return request({
        url: "/leakContact/searchLeakContactList",
        data: params,
        method: "post"
      });
    },
    //一括変更
    batchChange(params) {
      return request({
        url: "/leakContact/batchChange",
        data: params,
        method: "post"
      });
    }
  },
  // V024_対応履歴検索画面
  ContactSearch: {
    //初期表示
    indexContactSearch(params) {
      return request({
        url: "/contactSearch/indexContactSearch",
        data: params,
        method: "post"
      });
    },
    // 部署リスト取得
    searchDepartmentList(params) {
      return request({
        url: "/contactSearch/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchContactSearchList(params) {
      return request({
        url: "/contactSearch/searchContactSearchList",
        data: params,
        method: "post"
      });
    },
    outputCsv(params) {
      return request({
        url: "/contactSearch/outputCsv",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    // 対応コメント登録 新規登録
    insertContactComment(params) {
      return request({
        url: "/contactSearch/insertContactComment",
        data: params,
        method: "post"
      });
    },
    // 対応コメント登録 編集
    updateContactComment(params) {
      return request({
        url: "/contactSearch/updateContactComment",
        data: params,
        method: "post"
      });
    },
    // 対応コメント登録 初期表示
    indexContactComment(params) {
      return request({
        url: "/contactSearch/indexContactComment",
        data: params,
        method: "post"
      });
    },
    // 対応コメント登録 削除
    deleteContactComment(params) {
      return request({
        url: "/contactSearch/deleteContactComment",
        data: params,
        method: "post"
      });
    }
  },
  // V035_団体対応予定・対応履歴登録画面
  OrgContactEdit: {
    //団体対応履歴初期表示
    indexOrgContactEdit(params) {
      return request({
        url: "/orgContactEdit/indexOrgContactEdit",
        data: params,
        method: "post"
      });
    },
    //団体対応予定初期表示
    indexOrgContactTodoEdit(params) {
      return request({
        url: "/orgContactEdit/indexOrgContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    //団体対応予定・対応履歴登録 部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/orgContactEdit/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //対応履歴削除
    deleteOrgContactEdit(params) {
      return request({
        url: "/orgContactEdit/deleteOrgContactEdit",
        data: params,
        method: "post"
      });
    },
    //対応予定削除
    deleteOrgContactTotoEdit(params) {
      return request({
        url: "/orgContactEdit/deleteOrgContactTotoEdit",
        data: params,
        method: "post"
      });
    },
    //団体対応履歴登録(新規登録)
    insertOrgContactEdit(params) {
      return request({
        url: "/orgContactEdit/insertOrgContactEdit",
        data: params,
        method: "post"
      });
    },
    //団体対応履歴登録(編集)
    updateOrgContactEdit(params) {
      return request({
        url: "/orgContactEdit/updateOrgContactEdit",
        data: params,
        method: "post"
      });
    },
    //この予定を対応履歴に登録(編集)
    updateContactHistory(params) {
      return request({
        url: "/orgContactEdit/updateContactHistory",
        data: params,
        method: "post"
      });
    },
    //団体対応予定新規登録
    insertOrgContactTodoEdit(params) {
      return request({
        url: "/orgContactEdit/insertOrgContactTodoEdit",
        data: params,
        method: "post"
      });
    },
    //団体対応予定編集
    updateOrgContactTodoEdit(params) {
      return request({
        url: "/orgContactEdit/updateOrgContactTodoEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V089_社内予定登録
  MySchedule: {
    //初期表示
    indexMySchedule(params) {
      return request({
        url: "/mySchedule/indexMySchedule",
        data: params,
        method: "post"
      });
    },
    //登録（b2）をクリックしたときの処理(新規登録モード)
    insertMySchedule(params) {
      return request({
        url: "/mySchedule/insertMySchedule",
        data: params,
        method: "post"
      });
    },
    //登録（b2）をクリックしたときの処理(更新モード)
    updateMySchedule(params) {
      return request({
        url: "/mySchedule/updateMySchedule",
        data: params,
        method: "post"
      });
    },
    //削除(b3)ボタンクリック時の処理
    deleteMySchedule(params) {
      return request({
        url: "/mySchedule/deleteMySchedule",
        data: params,
        method: "post"
      });
    }
  }
};
